import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "grid" }
const _hoisted_2 = { id: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_offer_navigation_bar = _resolveComponent("offer-navigation-bar")!
  const _component_banner = _resolveComponent("banner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_footer_section = _resolveComponent("footer-section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_offer_navigation_bar),
    _createVNode(_component_banner),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_footer_section)
  ]))
}